import { SafeUrl } from '@angular/platform-browser';

export class AlbumModel {
    id: number;
    name: string;
    subCategories: AlbumModel[];
    imageUrl: SafeUrl;
}
